import { authorizedFetch } from '../../helpers/authorizedFetch'
import { formatDate } from '../../helpers/date'
import trans from '../../helpers/trans'
import { generateApiV3Url } from '../../helpers/url'
import { JapiDocument } from '../../japi/types/Document'
import { DateFormat } from '../../types/dateFormatTypes'
import { TimeModeType } from '../../types/timeModeTypes'
import { FetchResult, FetchResultType } from '../FetchResult'
import { UserWithInternalHourBalances } from './HourBalances'

interface getHourBalancesApiCallProps {
    startDate: Date;
    by?: TimeModeType
}

export const getHourBalancesApiCall = async ({
    startDate,
    by = TimeModeType.period,
}: getHourBalancesApiCallProps): Promise<FetchResult<UserWithInternalHourBalances[], string>> => {
    try {
        const url = generateApiV3Url({
            endpoint: `/users/hour-balances-for-me/${formatDate(startDate, DateFormat.apiDate)}`,
            queryParams: {
                by,
            },
        })

        const response = await authorizedFetch(url)

        const doc: JapiDocument = await response.json()

        if (! doc.data) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            }
        }

        const data = doc.data as UserWithInternalHourBalances[]

        return {
            status: response.status,
            type: FetchResultType.Success,
            totalPages: doc.meta?.pagination.pages,
            data,
        }
    } catch (error) {
        console.error('[getHourBalancesApiCall]', error)

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        }
    }
}
